<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getWxSdk } from '@/assets/js/getLocation';
export default {
  name: 'App',
  mounted() {
    //获取微信配置参数
    getWxSdk();
  }
}
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  font-size: .16rem;
}

img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue